// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WDW COLOR CODE */
/* AULANI COLOR CODE */
/**
 * variables.scss
 * Contains the sitewide variables
 */
/**
 * Breakpoints variables
 */
/**
 * Colors variables
 */
/**
 * z-index variables
 */
/**
 * function.scss
 * Contains the sitewide functions
 */
/**
 * mixins.scss
 * Contains the sitewide mixins
 */
/**
 * mixins.scss
 * Contains the sitewide mixins
 */
/**
 * global.scss
 * Contains the sitewide global styles
 */
* {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
*:before, *:after {
  box-sizing: border-box;
}
*:focus {
  outline: 1px dotted #000;
}

html,
body {
  margin: 0;
  min-height: 100vh;
}

body {
  width: 100%;
}

img {
  width: 100%;
}

h1,
h2,
h3,
h4,
h5 {
  margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
span,
a,
li,
p,
input,
textarea {
  font-family: inherit;
}

.clearfix, .pet-registration .page-section,
.pet-registration-mod-flow .page-section {
  zoom: 1;
}
.clearfix:after, .pet-registration .page-section:after,
.pet-registration-mod-flow .page-section:after {
  clear: both;
}
.clearfix:after, .pet-registration .page-section:after,
.pet-registration-mod-flow .page-section:after, .clearfix:before, .pet-registration .page-section:before,
.pet-registration-mod-flow .page-section:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

/**
 * reset.scss
 * Contains the sitewide css reset
 */
html,
body,
div,
span,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
abbr,
address,
address,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
samp,
small,
strong,
sub,
sup,
var,
b,
i,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
summary,
time,
mark,
audio,
video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
img,
menu,
nav,
section {
  display: block;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}
blockquote :before,
blockquote :after,
q :before,
q :after {
  content: none;
}

a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}

input,
select {
  vertical-align: middle;
}

address {
  font-style: normal;
}

input::-ms-clear {
  display: none;
}

button {
  background: none;
  border: 0;
  padding: 0;
}

.aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
.aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}

.border-section {
  margin: 30px 0 0;
  border-bottom: thin solid #D8D8D8;
}

.pet-registration {
  padding: 30px 10px 0;
}
.pet-registration h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: 0;
}
.pet-registration .left-section .content {
  margin-top: 2px;
}
.pet-registration .left-section .pet-icon-heading {
  display: flex;
}
.pet-registration .left-section .pet-icon-heading .pet-icon {
  width: 28px;
  height: 23px;
  margin: 0px 8px 0px 3px;
}
.pet-registration .right-section {
  width: 130px;
}

.pet-registration-mod-flow {
  padding: 16px 0 0;
}
.pet-registration-mod-flow h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: 0;
}
.pet-registration-mod-flow .left-section .content {
  margin-top: 1px;
}
.pet-registration-mod-flow .left-section p {
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
}
.pet-registration-mod-flow .left-section .pet-icon-heading {
  display: flex;
}
.pet-registration-mod-flow .left-section .pet-icon-heading .pet-icon {
  width: 28px;
  height: 23px;
  margin: 0px 8px 0px 3px;
}

.pet-registration.expanded,
.pet-registration-mod-flow.expanded {
  padding: 30px 0 0;
}
.pet-registration h3,
.pet-registration-mod-flow h3 {
  color: #253B56;
  font-family: "InspireTWDCHeavy";
  font-weight: 700;
  letter-spacing: -0.01px;
}
.pet-registration h3 _:default:not(:root:root), .pet-registration h3.safari_only,
.pet-registration-mod-flow h3 _:default:not(:root:root),
.pet-registration-mod-flow h3.safari_only {
  font-family: "InspireTWDC";
  font-weight: 700;
}
.pet-registration .left-section,
.pet-registration-mod-flow .left-section {
  float: left;
  width: 100%;
}
.pet-registration .left-section span,
.pet-registration-mod-flow .left-section span {
  font-size: 21px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  position: absolute;
  width: 30px;
  height: 30px;
  font-family: Peptasia-Miscellaneous;
  top: 2px;
  color: #253B56;
}
.pet-registration .left-section .content,
.pet-registration-mod-flow .left-section .content {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCMedium";
  padding-left: 1px;
}
.pet-registration .left-section .petCountText,
.pet-registration-mod-flow .left-section .petCountText {
  font-size: 14px;
  line-height: 21px;
  font-weight: 900;
  letter-spacing: 0;
  text-align: left;
}
.pet-registration .right-section,
.pet-registration-mod-flow .right-section {
  float: left;
  margin-top: 6px;
}
.pet-registration .right-section .section-edit,
.pet-registration-mod-flow .right-section .section-edit {
  font-family: "InspireTWDCMedium";
  font-size: 12px;
  line-height: 24px;
  font-weight: 500;
  letter-spacing: 0;
  color: #1B96D5;
  cursor: pointer;
}

@media (min-width: 767px) {
  .pet-registration {
    padding: 30px 40px 0;
  }
  .pet-registration .left-section .content {
    padding-left: 40px;
  }
  .pet-registration-mod-flow {
    padding-top: 16px;
  }
  .pet-registration-mod-flow .left-section .content {
    padding-left: 40px;
    margin-top: 0;
  }
  .pet-registration .left-section,
  .pet-registration-mod-flow .left-section {
    width: calc(100% - 130px);
    margin: 0;
    padding-right: 28px;
  }
  .pet-registration .left-section span,
  .pet-registration-mod-flow .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  .pet-registration .left-section .pin-error-msg,
  .pet-registration-mod-flow .left-section .pin-error-msg {
    margin-left: 40px;
  }
  .pet-registration .right-section,
  .pet-registration-mod-flow .right-section {
    padding-top: 18px;
    float: right;
    margin-top: 0;
  }
  .pet-registration .border-section,
  .pet-registration-mod-flow .border-section {
    width: 100%;
  }
}
/* For Desktop */
@media (min-width: 1024px) {
  .pet-registration {
    padding: 30px 40px 0;
  }
  .pet-registration .left-section {
    width: calc(100% - 130px);
  }
  .pet-registration .left-section span {
    font-size: 24px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  .pet-registration .left-section .content {
    padding-left: 40px;
  }
  .pet-registration-mod-flow {
    padding: 16px 0 0;
  }
  .pet-registration-mod-flow.expanded {
    padding-top: 30px;
  }
  .pet-registration-mod-flow h3 {
    margin-bottom: 0;
    line-height: 28px;
  }
  .pet-registration-mod-flow .left-section .content {
    padding-left: 40px;
    margin-top: 0px;
  }
  .pet-registration-mod-flow .left-section p {
    font-size: 0.86em;
    line-height: normal;
    font-family: "InspireTWDCBook";
    padding: 0 0 2px 0;
  }
  .pet-registration-mod-flow .left-section p.petCountText {
    font-size: 14px;
    line-height: 21px;
    font-weight: 900;
    letter-spacing: 0;
    text-align: left;
  }
  .pet-registration-mod-flow .left-section .petCountNumber {
    font-size: 40px;
    line-height: 35px;
    font-weight: 300;
    letter-spacing: 0;
    font-family: "InspireTWDCLight";
    color: #00233C;
    min-width: 80px;
    text-align: center;
  }
  .pet-registration .left-section,
  .pet-registration-mod-flow .left-section {
    margin: 0;
  }
  .pet-registration .left-section span,
  .pet-registration-mod-flow .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  .pet-registration .right-section,
  .pet-registration-mod-flow .right-section {
    padding-top: 18px;
    float: right;
    margin-top: 0;
  }
  .pet-registration .border-section,
  .pet-registration-mod-flow .border-section {
    width: 100%;
  }
}
.number-stepper {
  margin-top: 5px;
  display: flex;
  width: 145px;
  justify-content: space-between;
  align-items: center;
}
.number-stepper .number-stepper-button {
  width: 32px;
  height: 32px;
  gap: 0px;
  opacity: 0px;
  border: 1px solid #0079BC;
  border-radius: 50%;
  color: #0079BC;
  outline: none;
  font-size: x-large;
  cursor: pointer;
}
.number-stepper .number-stepper-button:hover {
  border: 1px solid #006096;
  color: #006096;
}
.number-stepper .number-stepper-button:active {
  border: 1px solid #083C5D;
  color: #083C5D;
}
.number-stepper .number-stepper-button:disabled {
  border: 1px solid #B7E4F7;
  color: #B7E4F7;
}
.number-stepper .petCountNumber {
  font-size: 40px;
  line-height: 35px;
  font-weight: 300;
  letter-spacing: 0;
  font-family: "InspireTWDCLight";
  color: #00233C;
  min-width: 80px;
  text-align: center;
}
.number-stepper .negative {
  padding-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/app/pet-registration/pet-registration.component.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/assets/style/base/font.scss"],"names":[],"mappings":"AAAA,mBAAA;AAkBA,sBAAA;AClBA;;;EAAA;AAKA;;EAAA;AAgBA;;EAAA;AAQA;;EAAA;AC7BA;;;EAAA;ACAA;;;EAAA;AAAA;;;EAAA;ACEA;;;EAAA;AAKA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ACyBJ;ADvBI;EAEI,sBAAA;ACwBR;ADrBI;EACI,wBAAA;ACuBR;;ADnBA;;EAEI,SAAA;EACA,iBAAA;ACsBJ;;ADnBA;EACI,WAAA;ACsBJ;;ADnBA;EACI,WAAA;ACsBJ;;ADnBA;;;;;EAKI,SAAA;ACsBJ;;ADnBA;;;;;;;;;;;;EAYI,oBAAA;ACsBJ;;ADnBA;;EACI,OAAA;ACuBJ;ADrBI;;EACI,WAAA;ACwBR;ADrBI;;;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ACwBR;;ADpBA;EACI,WAAA;ACuBJ;;ADpBA;EACI,YAAA;ACuBJ;;AC5GA;;;EAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AD8GJ;;AC3GA;;;;;;;;;;;;EAYI,cAAA;AD8GJ;;AC3GA;;EAEI,gBAAA;AD8GJ;;AC3GA;;EAEI,YAAA;AD8GJ;AC5GI;;;;EAEI,aAAA;ADgHR;;AC5GA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AD+GJ;;AC5GA;EACI,yBAAA;EACA,iBAAA;AD+GJ;;AC5GA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AD+GJ;;AC5GA;;EAEI,sBAAA;AD+GJ;;AC5GA;EACI,kBAAA;AD+GJ;;AC3GI;EACI,aAAA;AD8GR;;AC1GA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AD6GJ;;ACxGQ;EACI,gBAAA;EACA,cAAA;AD2GZ;ACvGY;EACI,cAAA;ADyGhB;;AA5QA;EACI,gBAAA;EACA,iCLGa;AK4QjB;;AA5QA;EACI,oBAAA;AA+QJ;AA7QI;EFUA,eETkB;EFUlB,iBEVwB;EFWxB,gBAH+C;EAI/C,iBAJqE;AE0QzE;AA9QQ;EACI,eAAA;AAgRZ;AA7QQ;EACI,aAAA;AA+QZ;AA7QY;EACI,WAAA;EACA,YAAA;EACA,uBAAA;AA+QhB;AAzQI;EACI,YAAA;AA2QR;;AAvQA;EACI,iBAAA;AA0QJ;AAxQI;EFnBA,eEoBkB;EFnBlB,iBEmBwB;EFlBxB,gBAH+C;EAI/C,iBAJqE;AEkSzE;AAzQQ;EACI,eAAA;AA2QZ;AAxQQ;EF5BJ,eE6BsB;EF5BtB,iBE4B4B;EF3B5B,gBAH+C;EAI/C,iBAJqE;AE2SzE;AA1QQ;EACI,aAAA;AA4QZ;AA1QY;EACI,WAAA;EACA,YAAA;EACA,uBAAA;AA4QhB;;AA9PI;;EACI,iBAAA;AAkQR;AA/PI;;EACI,cLxEiB;EKyEjB,+BE5EiB;EF6EjB,gBAAA;EACA,uBAAA;AAkQR;AAhQQ;;;EAEI,0BEtFO;EFuFP,gBAAA;AAmQZ;AA/PI;;EFxDA,WAAA;EE0DI,WAAA;AAkQR;AAhQQ;;EFzEJ,eE0EsB;EFzEtB,iBEyE4B;EFxE5B,gBAH+C;EAI/C,iBAJqE;EE4E7D,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,QAAA;EACA,cL/Fa;AKqWzB;AAnQQ;;EFnFJ,eEoFsB;EFnFtB,iBEmF4B;EFlF5B,gBAH+C;EAI/C,iBAJqE;EEsF7D,cLpGa;EKqGb,gCEzGc;EF0Gd,iBAAA;AAyQZ;AAtQQ;;EF1FJ,eE2FsB;EF1FtB,iBE0F4B;EFzF5B,gBEyFkC;EFxFlC,iBEwFuC;EAC/B,gBAAA;AA4QZ;AAxQI;;EFnFA,WAAA;EEqFI,eAAA;AA2QR;AAzQQ;;EACI,gCExHc;EJmBtB,eEuGsB;EFtGtB,iBEsG4B;EFrG5B,gBEqGkC;EFpGlC,iBEoGuC;EAC/B,cAAA;EACA,eAAA;AA8QZ;;AAzQA;EACI;IACI,oBAAA;EA4QN;EAzQU;IACI,kBAAA;EA2Qd;EAtQE;IACI,iBAAA;EAwQN;EArQU;IACI,kBAAA;IACA,aAAA;EAuQd;EAhQM;;IACI,yBAAA;IACA,SAAA;IACA,mBAAA;EAmQV;EAjQU;;IACI,WAAA;IACA,YAAA;IACA,eAAA;EAoQd;EAjQU;;IACI,iBAAA;EAoQd;EAhQM;;IACI,iBAAA;IACA,YAAA;IACA,aAAA;EAmQV;EAhQM;;IACI,WAAA;EAmQV;AACF;AA/PA,gBAAA;AACA;EACI;IACI,oBAAA;EAiQN;EA/PM;IACI,yBAAA;EAiQV;EA/PU;IF1KR,eE2K0B;IF1K1B,iBE0KgC;IFzKhC,gBAH+C;IAI/C,iBAJqE;EEgbvE;EAjQU;IACI,kBAAA;EAmQd;EA9PE;IACI,iBAAA;EAgQN;EA9PM;IACI,iBAAA;EAgQV;EA7PM;IACI,gBAAA;IACA,iBAAA;EA+PV;EA3PU;IACI,kBAAA;IACA,eAAA;EA6Pd;EA1PU;IACI,iBAAA;IACA,mBAAA;IACA,8BE9NQ;IF+NR,kBAAA;EA4Pd;EAzPU;IF7MR,eE8M0B;IF7M1B,iBE6MgC;IF5MhC,gBE4MsC;IF3MtC,iBE2M2C;IAC/B,gBAAA;EA8Pd;EA3PU;IFlNR,eEmN0B;IFlN1B,iBEkNgC;IFjNhC,gBEiNsC;IFhNtC,iBEgN2C;IAC/B,+BExOS;IFyOT,cLhMK;IKiML,eAAA;IACA,kBAAA;EAgQd;EAzPM;;IACI,SAAA;EA4PV;EA1PU;;IACI,WAAA;IACA,YAAA;IACA,eAAA;EA6Pd;EAzPM;;IACI,iBAAA;IACA,YAAA;IACA,aAAA;EA4PV;EAzPM;;IACI,WAAA;EA4PV;AACF;AAvPA;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;AAyPJ;AAvPI;EACI,WAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cL/OgB;EKgPhB,aAAA;EACA,kBAAA;EACA,eAAA;AAyPR;AAvPQ;EACI,yBAAA;EACA,cLpPU;AK6etB;AAtPQ;EACI,yBAAA;EACA,cLxPW;AKgfvB;AArPQ;EACI,yBAAA;EACA,cL5Pa;AKmfzB;AAnPI;EFxRA,eEyRkB;EFxRlB,iBEwRwB;EFvRxB,gBEuR8B;EFtR9B,iBEsRmC;EAC/B,+BE9SiB;EF+SjB,cLtQa;EKuQb,eAAA;EACA,kBAAA;AAwPR;AArPI;EACI,mBAAA;AAuPR","sourcesContent":["/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.border-section {\r\n    margin: 30px 0 0;\r\n    border-bottom: $primary-border;\r\n}\r\n\r\n.pet-registration {\r\n    padding: 30px 10px 0;\r\n\r\n    h3 {\r\n        @include font(16px, 28px);\r\n    }\r\n\r\n    .left-section {\r\n        .content {\r\n            margin-top: 2px;\r\n        }\r\n\r\n        .pet-icon-heading {\r\n            display: flex;\r\n\r\n            .pet-icon {\r\n                width: 28px;\r\n                height: 23px;\r\n                margin: 0px 8px 0px 3px;\r\n            }\r\n\r\n        }\r\n    }\r\n\r\n    .right-section {\r\n        width: 130px;\r\n    }\r\n}\r\n\r\n.pet-registration-mod-flow {\r\n    padding: 16px 0 0;\r\n\r\n    h3 {\r\n        @include font(16px, 28px);\r\n    }\r\n\r\n    .left-section {\r\n        .content {\r\n            margin-top: 1px;\r\n        }\r\n\r\n        p {\r\n            @include font(12px, 20px);\r\n        }\r\n\r\n        .pet-icon-heading {\r\n            display: flex;\r\n\r\n            .pet-icon {\r\n                width: 28px;\r\n                height: 23px;\r\n                margin: 0px 8px 0px 3px;\r\n            }\r\n\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.pet-registration,\r\n.pet-registration-mod-flow {\r\n    .page-section {\r\n        @extend .clearfix;\r\n    }\r\n\r\n    &.expanded {\r\n        padding: 30px 0 0;\r\n    }\r\n\r\n    h3 {\r\n        color: $wdw-primary-text-color;\r\n        font-family: $inspiretwdc-heavy-font;\r\n        font-weight: 700;\r\n        letter-spacing: -0.01px;\r\n\r\n        _:default:not(:root:root),\r\n        &.safari_only {\r\n            font-family: $inspiretwdc-font;\r\n            font-weight: 700;\r\n        }\r\n    }\r\n\r\n    .left-section {\r\n        @include float-left;\r\n        width: 100%;\r\n\r\n        span {\r\n            @include font(21px, 21px);\r\n            position: absolute;\r\n            width: 30px;\r\n            height: 30px;\r\n            font-family: Peptasia-Miscellaneous;\r\n            top: 2px;\r\n            color: $wdw-primary-text-color;\r\n        }\r\n\r\n        .content {\r\n            @include font(14px, 21px);\r\n            color: $wdw-primary-text-color;\r\n            font-family: $inspiretwdc-medium-font;\r\n            padding-left: 1px;\r\n        }\r\n\r\n        .petCountText {\r\n            @include font(14px, 21px, 900, 0);\r\n            text-align: left;\r\n        }\r\n    }\r\n\r\n    .right-section {\r\n        @include float-left;\r\n        margin-top: 6px;\r\n\r\n        .section-edit {\r\n            font-family: $inspiretwdc-medium-font;\r\n\r\n            @include font(12px, 24px, 500, 0);\r\n            color: #1B96D5;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .pet-registration {\r\n        padding: 30px 40px 0;\r\n\r\n        .left-section {\r\n            .content {\r\n                padding-left: 40px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .pet-registration-mod-flow {\r\n        padding-top: 16px;\r\n\r\n        .left-section {\r\n            .content {\r\n                padding-left: 40px;\r\n                margin-top: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    .pet-registration,\r\n    .pet-registration-mod-flow {\r\n        .left-section {\r\n            width: calc(100% - 130px);\r\n            margin: 0;\r\n            padding-right: 28px;\r\n\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n            }\r\n\r\n            .pin-error-msg {\r\n                margin-left: 40px;\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            padding-top: 18px;\r\n            float: right;\r\n            margin-top: 0;\r\n        }\r\n\r\n        .border-section {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n/* For Desktop */\r\n@media (min-width: 1024px) {\r\n    .pet-registration {\r\n        padding: 30px 40px 0;\r\n\r\n        .left-section {\r\n            width: calc(100% - 130px);\r\n\r\n            span {\r\n                @include font(24px, 24px);\r\n            }\r\n\r\n            .content {\r\n                padding-left: 40px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .pet-registration-mod-flow {\r\n        padding: 16px 0 0;\r\n\r\n        &.expanded {\r\n            padding-top: 30px;\r\n        }\r\n\r\n        h3 {\r\n            margin-bottom: 0;\r\n            line-height: 28px;\r\n        }\r\n\r\n        .left-section {\r\n            .content {\r\n                padding-left: 40px;\r\n                margin-top: 0px;\r\n            }\r\n\r\n            p {\r\n                font-size: 0.86em;\r\n                line-height: normal;\r\n                font-family: $inspiretwdc-book-font;\r\n                padding: 0 0 2px 0;\r\n            }\r\n\r\n            p.petCountText {\r\n                @include font(14px, 21px, 900, 0);\r\n                text-align: left;\r\n            }\r\n\r\n            .petCountNumber {\r\n                @include font(40px, 35px, 300, 0);\r\n                font-family: $inspiretwdc-light-font;\r\n                color: $default-text-color;\r\n                min-width: 80px;\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n\r\n    .pet-registration,\r\n    .pet-registration-mod-flow {\r\n        .left-section {\r\n            margin: 0;\r\n\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            padding-top: 18px;\r\n            float: right;\r\n            margin-top: 0;\r\n        }\r\n\r\n        .border-section {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.number-stepper {\r\n    margin-top: 5px;\r\n    display: flex;\r\n    width: 145px;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    .number-stepper-button {\r\n        width: 32px;\r\n        height: 32px;\r\n        gap: 0px;\r\n        opacity: 0px;\r\n        border: 1px solid $default-button-border;\r\n        border-radius: 50%;\r\n        color: $default-button-border;\r\n        outline: none;\r\n        font-size: x-large;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            border: 1px solid $hover-button-border;\r\n            color: $hover-button-border;\r\n        }\r\n\r\n        &:active {\r\n            border: 1px solid $active-button-border;\r\n            color: $active-button-border;\r\n        }\r\n\r\n        &:disabled {\r\n            border: 1px solid $disabled-button-border;\r\n            color: $disabled-button-border;\r\n        }\r\n    }\r\n\r\n    .petCountNumber {\r\n        @include font(40px, 35px, 300, 0);\r\n        font-family: $inspiretwdc-light-font;\r\n        color: $default-text-color;\r\n        min-width: 80px;\r\n        text-align: center;\r\n    }\r\n\r\n    .negative {\r\n        padding-bottom: 5px;\r\n    }\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
